// ══════════════════════════════════════════════════════════════════════════════════════════════
//  QUÉ FUNCIONES EN DESARROLLO ESTÁN ENCENDIDAS PARA ESTA CLÍNICA (t279, 17-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Las funciones grandes que se desarrollan para la 2.0 o la 3.0 de Biango (shared/funciones.json) pasan a producción
//  APAGADAS: el servidor manda en GET /api/config-cliente la lista de las encendidas para la clínica de quien entra (en
//  pruebas, todas; en producción, de fábrica ninguna), hooks/useBranding la apunta aquí, y lo leen hooks/useFuncion,
//  components/SoloConFuncion y el menú lateral (components/Layout: una entrada con `funcion: 'clave'` no sale apagada).
//
//  SIN IMPORTS, A PROPÓSITO: lo cargan de verdad decenas de guardias (el menú lateral, la marca) y así no arrastra nada.
//  Mientras no ha llegado la respuesta (`null`) NADA está encendido: equivocarse hacia «apagada» lo arregla la respuesta
//  medio segundo después; hacia «encendida» enseñaría a una clínica lo que no está terminado.
let encendidas = null
const oyentes = new Set()

export function ponerFuncionesEncendidas(lista) {
  encendidas = new Set(Array.isArray(lista) ? lista.filter((c) => typeof c === 'string') : [])
  for (const f of [...oyentes]) { try { f() } catch (_) { /* un oyente roto no para a los demás */ } }
  return encendidas
}

export function funcionEncendida(clave) {
  return !!encendidas && encendidas.has(String(clave))
}

// ¿Ha contestado ya el servidor? (Una ruta de una función no expulsa a nadie antes de saberlo.)
export function funcionesSabidas() {
  return encendidas !== null
}

export function suscribirFunciones(f) {
  oyentes.add(f)
  return () => { oyentes.delete(f) }
}

// Lo que pide un dibujo de React (useSyncExternalStore): cambia cada vez que llega la lista.
export function fotoFunciones() {
  return encendidas === null ? '' : [...encendidas].sort().join(',') || '-'
}
